<template>
    <div>
        Bienvenido
    </div>
</template>
<script>
    export default {

    }
</script>